import useSWR from 'swr';

import { useUser, useCurrentProjectId } from '@adsk/alloy-provider';

import { FORMS_SWR_CONFIG } from '../helpers/constants';
import { transformHQUserToPgUser } from '../helpers/transformers/transformHqUserToPgUser';

export default () => {
  const projectId = useCurrentProjectId();
  const { user: oxygenUser } = useUser();

  const { data, error } = useSWR(
    oxygenUser ? `oxygen-user-${projectId}-${oxygenUser.id}` : null,
    () => transformHQUserToPgUser(oxygenUser),
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
